import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  View,
  ScrollView,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  Dimensions,
  Alert,
} from "react-native";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import chapterActions from "app/utils/chapterActions";
import storageActions from "app/utils/storageActions";
import valueActions from "app/utils/valueActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import colorHelpers from "app/utils/colorHelpers";
import timeHelpers from "app/utils/timeHelpers";

import MomentBullet from "app/components/chapter/MomentBullet";
import MomentList from "app/components/chapter/MomentList";
import Chapter from "app/components/Chapter";
import Icon from "app/components/Icon";
import Badge from "app/components/chapter/Badge";
import HoverableTooltip from "app/components/HoverableTooltip";
import AreaGraph from "app/components/AreaGraph";

import store from "app/redux/store";
import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class Waves extends React.Component {
  static contextType = StyleContext;
  constructor(props, context) {
    super(props, context);
    let { navigation, route } = this.props;

    this.state = {
      chapters: [],
      moments: [],
      values: [],
      nestedValues: [],
      loading: true,
      graphValues: [],
    };
  }

  async componentDidMount() {
    this.fetch();
  }

  fetch = async () => {
    let res = await valueActions.get(9399, null, true);
    console.log(res);
    this.setState({
      loading: false,
      startAt: res.start_at,
      chapters: res.chapters,
      // moments: res.moments,
      value: res.value,
      // parents
      // referencers
      values: res.sub_moment_values, //(76)
      moments: res.sub_moments, //(168)
      graphValues: [
        ...this.state.graphValues,
        { value: res.value, moments: res.sub_moments },
      ],
    });
    res = await valueActions.get(6617, null, true);
    console.log(res);
    this.setState({
      graphValues: [
        ...this.state.graphValues,
        { value: res.value, moments: res.sub_moments },
      ],
    });
    res = await valueActions.get(765, null, true);
    console.log(res);
    this.setState({
      graphValues: [
        ...this.state.graphValues,
        { value: res.value, moments: res.sub_moments },
      ],
    });
    res = await valueActions.get(893, null, true);
    console.log(res);
    this.setState({
      graphValues: [
        ...this.state.graphValues,
        { value: res.value, moments: res.sub_moments },
      ],
    });
    // } else {
    //   let error = res?.error || "error";
    //   console.warn(error);
    // }
  };

  render() {
    let { loading, startAt, chapters, moments, value, values, selectedValue } =
      this.state;

    return (
      <View style={[this.styles().container]}>
        <StatusBar style="auto" />

        <View style={{ height: this.context.sizes.base }} />

        <ScrollView style={this.styles().scroller}>
          {loading && <ActivityIndicator />}

          <Text>{!!value?.id && `${value.title}\n\n`}</Text>

          {this.renderContent()}
        </ScrollView>
        {!!selectedValue && (
          <View style={{ margin: 20 }}>
            <MomentBullet
              moment={{ value: selectedValue }}
              onEscape={() => this.setState({ selectedValue: null })}
            />
          </View>
        )}
      </View>
    );
  }

  renderContent = () => {
    let { value, moments, values } = this.state;
    let valueColor =
      valueHelpers.colorAsHex(value?.color) || this.context.colors.trim;

    let mutatedValues = values.map((v) => {
      let value = { ...v };
      value.moments = moments.filter((m) => m.value_id === v.id);
      return value;
    });

    mutatedValues = mutatedValues.sort((a, b) => {
      let aTs = a.moments.length;
      let bTs = b.moments.length;
      if (aTs > bTs) return -1;
      if (aTs < bTs) return 1;
      return 0;
    });

    return (
      <View>
        <AreaGraph
          // moments={moments}
          // value={value}
          data={this.state.graphValues}
        />
        ;
        {mutatedValues.map((value, i) => {
          // let ts = moment.completed_at || moment.updated_at;
          // ts = timeHelpers.dateTimeToDate(ts);
          let ts = ">";
          // let value = values.find((v) => v.id === moment.value_id);
          return (
            <TouchableWithoutFeedback
              onPress={() => this.setState({ selectedValue: value })}
            >
              <View
                style={[this.styles().itemWrapper, { flexDirection: "row" }]}
              >
                <MomentBullet moment={{ value }} />
                <Text>({value.moments.length})</Text>
              </View>
            </TouchableWithoutFeedback>
          );
        })}
        {moments.map((moment, i) => {
          let ts = moment.completed_at || moment.updated_at;
          ts = timeHelpers.dateTimeToDate(ts);
          let value = values.find((v) => v.id === moment.value_id);
          return (
            <View style={this.styles().itemWrapper}>
              <Text>
                {ts} {value.title}
              </Text>
            </View>
          );
        })}
      </View>
    );
  };

  getTopLevelIds = (values) => {
    let allValueIds = values.map((v) => v.id);
    let topLevelIds = [];
    for (let i = 0; i < values.length; i++) {
      let value = values[i];
      let hasParent = value.parent_ids.some((id) => allValueIds.includes(id));
      if (!hasParent) {
        topLevelIds.push(value.id);
      }
    }
    return topLevelIds;
  };

  nestValues = (data) => {
    let { chapters, moments, values } = data;
    let allValueIds = values.map((v) => v.id);
    let topLevel = [];
    let children = [];
    for (let i = 0; i < values.length; i++) {
      let value = values[i];
      let hasParent = value.parent_ids.some((id) => allValueIds.includes(id));
      if (hasParent) {
        children.push(value);
      } else {
        topLevel.push(value);
      }
    }
    topLevel = topLevel.map((value) => {
      let children = values.filter((v) => v.parent_ids.includes(value.id));
      return {
        ...value,
        children: children,
      };
    });
    let nestedValues = topLevel;
    return nestedValues;
  };

  styles = () => ({
    container: {
      flex: 1,
      // alignItems: 'center',
      // alignItems: 'stretch',
    },
    scroller: {
      // padding: this.context.sizes.base,
    },
    itemWrapper: {
      flexDirection: "row",
    },
    item: {
      padding: 2,
      marginBottom: 5,
      marginLeft: 20,
      borderColor: this.context.colors.trim,
      // borderBottomWidth: 1,
      borderLeftWidth: 1,
    },
  });
}
